import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ui-checkbox',
  template: `
    <div class="checkbox-group">
      <button
        type="button"
        class="checkbox"
        [class.checkbox--active]="checked"
        [disabled]="disabled"
        (click)="toggle()"
      >
        <span class="checkbox__dot"></span>
      </button>
      <span *ngIf="label" class="checkbox__label">{{ label }}</span>
    </div>
  `,
  styleUrls: ['./ui-checkbox.component.css']
})
export class UiCheckboxComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() label?: string;
  @Output() checkedChange = new EventEmitter<boolean>();

  toggle() {
    if (this.disabled) {
      return;
    }
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }
}
